import { stationsActions } from '../reducer';

export const resetFilteredStations = () => stationsActions.resetFilteredStations();
